import type { LocaleObject } from "@nuxtjs/i18n";
import type { NuxtConfig } from "nuxt/schema";

export const availableLocales = [
  {
    code: "en",
    language: "en-GB",
    file: "en_GB.json",
    abbreviation: "en",
    // name: "English (UK)",
    // @TODO USA - Change to "English (UK)" when USA language is live
    name: "English",
  },

  {
    code: "us",
    language: "en-US",
    file: "en_US.json",
    abbreviation: "en",
    name: "English (US)",
  },

  {
    code: "nl",
    language: "nl-NL",
    file: "nl_NL.json",
    abbreviation: "nl",
    name: "Nederlands",
  },

  {
    code: "fr",
    language: "fr-FR",
    file: "fr_FR.json",
    abbreviation: "fr",
    name: "Français",
  },

  {
    code: "de",
    language: "de-DE",
    file: "de_DE.json",
    abbreviation: "de",
    name: "Deutsch",
  },

  {
    code: "it",
    language: "it-IT",
    file: "it_IT.json",
    abbreviation: "it",
    name: "Italiano",
  },

  {
    code: "id",
    language: "id-ID",
    file: "id_ID.json",
    abbreviation: "id",
    name: "Bahasa Indonesia",
  },

  {
    code: "es",
    language: "es-ES",
    file: "es_ES.json",
    abbreviation: "es",
    name: "Español",
  },

  {
    code: "pt",
    language: "pt-PT",
    file: "pt_PT.json",
    abbreviation: "pt",
    name: "Português",
  },

  {
    code: "br",
    language: "pt-BR",
    file: "pt_BR.json",
    abbreviation: "pt",
    name: "Português do Brasil",
  },

  {
    code: "ja",
    language: "ja-JP",
    file: "ja_JP.json",
    abbreviation: "ja",
    name: "日本語",
  },

  {
    code: "zh",
    language: "zh-CN",
    file: "zh_CN.json",
    abbreviation: "zh",
    name: "简体中文",
  },
  {
    code: "tr",
    language: "tr-TR",
    file: "tr_TR.json",
    abbreviation: "tr",
    name: "Türkçe",
  },
  {
    code: "ko",
    language: "ko-KR",
    file: "ko_KR.json",
    abbreviation: "ko",
    name: "한국어",
  },
] as const satisfies LocaleObject[];

/**
 * See: https://i18n.nuxtjs.org/getting-started/setup
 */
const nuxtI18nModuleConfig = {
  strategy: "prefix_and_default",
  compilation: {
    strictMessage: false, // so that the html messages in the translations don't break the build
  },
  langDir: "crowdin/",
  locales: availableLocales,
  defaultLocale: "en",
  // We handle browser language detection ourselves on the client,
  // as it intervenes with our initial doc caching.
  detectBrowserLanguage: false,
  vueI18n: "./vueI18nConfig.ts",
  experimental: {
    typedOptionsAndMessages: "all",
  },
} satisfies NuxtConfig["i18n"];

export default nuxtI18nModuleConfig;
